import { changeLanguage } from "@/lang/i18n.js";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(
          /* webpackChunkName: "notify" */ "@/views/Home.vue"
        )
    },
    {
      path: "/notify/tracking-page",
      name: "tracking-page",
      component: () =>
        import(
          /* webpackChunkName: "notify" */ "@/views/Notify.vue"
        ),
      props: { displayInstructionBar: true }
    },
    {
      path: "/shipping/shipping-rules",
      name: "shipping-rules",
      component: () =>
        import(
          /* webpackChunkName: "shipping" */ "@/views/Shipping.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/shipping/incoming-orders",
      name: "incoming-orders",
      component: () =>
        import(
          /* webpackChunkName: "incoming-orders" */ "@/views/IncomingOrdersView.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/returns/portal",
      name: "returns-portal",
      component: () =>
        import(
          /* webpackChunkName: "returns" */ "@/views/Returns.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/pack-go",
      name: "pack-go",
      component: () =>
        import(
          /* webpackChunkName: "pack-go" */ "@/views/PackGo/Index.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/pack-go/back",
      name: "pack-go",
      component: () =>
        import(
          /* webpackChunkName: "pack-go" */ "@/views/PackGo/back.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/pack-go/automatic-mode",
      name: "pack-go-autmatic-mode",
      component: () =>
        import(
          /* webpackChunkName: "pack-go" */ "@/views/PackGo/AutomaticMode.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/pack-go/print",
      name: "print",
      component: () =>
        import(
          /* webpackChunkName: "pack-go" */ "@/views/PackGo/Print.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/pack-go/scanner",
      name: "scanner",
      component: () =>
        import(
          /* webpackChunkName: "pack-go" */ "@/views/PackGo/Scanner.vue"
        ),
      props: { displayInstructionBar: true }
    },

    {
      path: "/checkout/dynamic-checkout",
      name: "dynamic-checkout",
      component: () =>
        import(
          /* webpackChunkName: "pack-go" */ "@/views/DynamicCheckout.vue"
        ),
      props: { displayInstructionBar: true }
    },

    /* EMBEDS HERE */

    {
      path: "/embed/incoming-orders",
      name: "incoming-orders-embed",
      component: () =>
        import(
          /* webpackChunkName: "shipping" */ "@/views/IncomingOrdersView.vue"
        )
    },

    {
      path: "/embed/pack-go",
      name: "pack-go-embed",
      component: () =>
        import(
          /* webpackChunkName: "shipping" */ "@/views/PackGo/Index.vue"
        )
    },

    {
      path: "/embed/shipping-rules",
      name: "shipping-rules-embed",
      component: () =>
        import(
          /* webpackChunkName: "shipping" */ "@/views/Shipping.vue"
        )
    },
    {
      path: "/embed/tracking-page",
      name: "tracking-page-embed",
      component: () =>
        import(
          /* webpackChunkName: "notify" */ "@/views/Notify.vue"
        )
    },
    {
      path: "/embed/returns-portal",
      name: "returns-portal-embed",
      component: () =>
        import(
          /* webpackChunkName: "returns" */ "@/views/Returns.vue"
        )
    },
  ]
});

router.beforeEach((to, from, next) => {
  const lang = to.query.lang
  if (lang) changeLanguage(lang)
  next()
})

export default router